module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGMICnL9TwlmGDVg1IBRA4aLAQCBEugQw5MS3QAAAABJRU5ErkJggg=="